import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="socialMedia">
        {/* <InstagramIcon />
        <TwitterIcon />
        <FacebookIcon /> */}
        <a href="https://www.linkedin.com/in/saurav-kumar-b57ab318b/"><LinkedInIcon/></a>
        {/* <a><GithubIcon/></a> */}
        <a href="https://github.com/sauravkumar02"><GitHubIcon/></a>
      </div>
      <p> &copy; 2023 sauravkumarportfolio.netlify.app</p>
    </div>
  );
}

export default Footer;
